import React from 'react'
import axiosSmartSurvey from '../../../api/axios'

export default function useAmountOfCultivation() {
    function fetchAmountOfCultivation(setCropList) {
        axiosSmartSurvey({
            method: 'post',
            url: '/calculator/cropamount',
        }).then((response) => {
            response = response.data
            console.log(response)
            setCropList(response.cropAmount)
        }).catch((err) => {
            console.log(err)
        })
    }
    return { fetchAmountOfCultivation }
}
